var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefNumber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66.16 44.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 77"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M1.5 1.5h63.16v41.45H1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M14.08 18.22c0-2.62 1.11-4.2 3.07-4.2s3.07 1.58 3.07 4.2-1.12 4.2-3.07 4.2-3.07-1.57-3.07-4.2m4.21 0c0-1.57-.41-2.46-1.14-2.46S16 16.65 16 18.22s.41 2.46 1.14 2.46 1.15-.87 1.15-2.46m4.27-1.54h-1.15a.23.23 0 0 1-.22-.23v-.76a.33.33 0 0 1 .08-.18L23 14.14h1.1a.23.23 0 0 1 .22.23v7.7a.23.23 0 0 1-.22.23h-1.31a.23.23 0 0 1-.23-.23zM26 18.22c0-2.62 1.11-4.2 3.07-4.2s3.07 1.58 3.07 4.2-1.12 4.2-3.07 4.2S26 20.85 26 18.22m4.21 0c0-1.57-.41-2.46-1.14-2.46S28 16.65 28 18.22s.41 2.46 1.14 2.46 1.09-.87 1.09-2.46zm2.84 3.61c.7-.91 2.47-3.32 3.18-4.4a1.83 1.83 0 0 0 .31-.91c0-.46-.38-.86-1.06-.86a1.68 1.68 0 0 0-1.16.6.25.25 0 0 1-.34 0l-.73-.75a.23.23 0 0 1 0-.31 3.44 3.44 0 0 1 2.39-1.2 2.47 2.47 0 0 1 2.72 2.43 3.05 3.05 0 0 1-.47 1.57c-.38.68-1.36 2-1.93 2.76h2.11a.23.23 0 0 1 .23.22v1.08a.24.24 0 0 1-.23.23h-4.79a.23.23 0 0 1-.23-.23zm6.56-3.61c0-2.62 1.12-4.2 3.07-4.2s3.07 1.58 3.07 4.2-1.11 4.2-3.07 4.2-3.07-1.57-3.07-4.2m4.21 0c0-1.57-.4-2.46-1.14-2.46s-1.14.89-1.14 2.46.41 2.46 1.14 2.46 1.14-.87 1.14-2.46m2.95 2.83.75-.75a.22.22 0 0 1 .3 0 2.86 2.86 0 0 0 1.32.55 1 1 0 0 0 1-.95c0-.53-.54-1-1.42-1h-.67a.23.23 0 0 1-.23-.22v-1a.23.23 0 0 1 .23-.23h.67c.84 0 1.28-.4 1.28-.92a.92.92 0 0 0-1-.9 1.37 1.37 0 0 0-1 .48.23.23 0 0 1-.33 0l-.67-.72a.22.22 0 0 1 0-.31A3.54 3.54 0 0 1 49.27 14a2.36 2.36 0 0 1 2.59 2.2 2.16 2.16 0 0 1-1.23 1.86 2.41 2.41 0 0 1 1.45 2c0 1.31-1.14 2.29-2.8 2.29a3.1 3.1 0 0 1-2.53-1.07.23.23 0 0 1 .02-.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M14.7 28.22h36.75"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefNumber);
export default __webpack_public_path__ + "static/media/refNumber.d1a3e5400d03b0d0d701c0a3021997af.svg";
export { ForwardRef as ReactComponent };